import { useSearchParams } from 'react-router-dom'
import apiAsync from '../../utils/api-async'
import { useAuthentication } from 'authentication'
import { useTranslation } from 'react-i18n-lite'
import { defaultLanguage } from './I18n'

export function RedirectToLogin() {
  const [searchParams] = useSearchParams()
  const { language } = useTranslation()

  const { token: tokenInState } = useAuthentication()
  const tokenInQuery = searchParams.get('token')
  const tokenInLocalStorage = localStorage.getItem('token')

  const token = tokenInState || tokenInQuery || tokenInLocalStorage

  apiAsync.setAuthToken(token)

  if (!token) {
    window.location = `${window.waAuthenticationUrl}login?redirectOrigin=${
      window.location.href
    }&lang=${language || defaultLanguage}`
  }

  return null
}

export default RedirectToLogin
